// Split out of summary_dws.js so summaryTable/tableEditMode.ts (which summary_dws.js
// itself depends on via presenter/summaryTable.ts) doesn't need to import summary_dws.js
// and create a circular dependency.

export let userIds = [];

export function setUserIds(ids) {
  userIds = ids;
}

export function updateSlotMapSections(sections) {
  sections?.forEach(section => {
    SlotMap[section.ID] = section;
  });
}
